// extracted by mini-css-extract-plugin
export default {"SinConfigurarWrapper":"SinConfigurar_SinConfigurarWrapper__xc7nU","SinConfigurarContainer":"SinConfigurar_SinConfigurarContainer__TlbVw","TextoInfo":"SinConfigurar_TextoInfo__ghXv5"};